import { useCallback, useEffect, useRef } from 'react';
import { PosturalAnalytics, UseControls } from '../context/Controls.context';
import { TransitionStates, UseTransition } from '../context/Transition.context';
import { NormalizedLandmark } from '@mediapipe/tasks-vision';
import EventEmitter from '@services/EventEmitter';
import { useNavigate, useParams } from 'react-router-dom';
import { router } from '@routers/routers';
import { useTypedDispatch } from '@stores/index';
import { setOnBoardCompletion } from '@stores/onBoard/onBoard';

function Controls(props: { isDashboard?: boolean }) {
	const navigate = useNavigate();
	const { isDashboard } = props;
	const { transition } = UseTransition();
	const {
		onSubmit,
		onGetCurrent,
		processAndCapturePosture,
		postureAnalyticsSessionId,
		results,
		isCompleted,
		canvasDimensions,
	} = UseControls();
	const dispatch = useTypedDispatch();

	const { userId } = useParams();

	const current = onGetCurrent() as Partial<PosturalAnalytics>;

	const hasCapturedRef = useRef(false);

	const frameCallback = useCallback(
		(results: NormalizedLandmark[]) => {
			if (
				transition?.value === TransitionStates.CLOSING &&
				!hasCapturedRef.current
			) {
				hasCapturedRef.current = true;
				processAndCapturePosture(results, canvasDimensions);
			} else if (transition?.value !== TransitionStates.CLOSING) {
				hasCapturedRef.current = false;
			}
		},
		[transition, processAndCapturePosture, canvasDimensions],
	);

	useEffect(() => {
		EventEmitter.once('results', results => {
			frameCallback(results);
		});

		return () => {
			EventEmitter.off('results');
		};
	}, [frameCallback]);

	useEffect(() => {
		results && onSubmit();
	}, [results]);

	useEffect(() => {
		if (isCompleted && !isDashboard) {
			navigate(`/${userId}${router.AIASSISTANT_POSTURE_SUMMARY}`, {
				state: { id: postureAnalyticsSessionId, replace: true },
			});
		} else if (isCompleted && isDashboard) {
			dispatch(setOnBoardCompletion(true));
		}
	}, [isCompleted, navigate, userId]);

	if (current?.completed || transition?.value !== TransitionStates.RESULT)
		return null;

	return <></>;
}

export default Controls;
